import { render, staticRenderFns } from "./DoughnutComp.vue?vue&type=template&id=3c01d400"
import script from "./DoughnutComp.vue?vue&type=script&lang=js"
export * from "./DoughnutComp.vue?vue&type=script&lang=js"
import style0 from "./DoughnutComp.vue?vue&type=style&index=0&id=3c01d400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports